import React, { useEffect, useMemo, useState } from 'react';
import DashboardLayout from '../DashboardLayout/DashboardLayout';
import type { NavItem } from '../DashboardLayout/DashboardLayout';
import { useNotifications } from '../../../contexts/NotificationContext';

const UserLayout: React.FC = () => {
  const { unreadCount } = useNotifications();

  const navItems: NavItem[] = useMemo(
    () => [
      { path: '/dashboard', icon: 'bi-house', label: 'Dashboard', end: true },
      {
        path: '/dashboard/corsi',
        icon: 'bi-play-circle',
        label: 'I miei corsi',
        labelShort: 'Corsi',
      },
      {
        path: '/dashboard/fit-anatomy',
        icon: 'bi-heart-pulse',
        label: 'Fit Anatomy',
        labelShort: 'Fit',
      },
      { path: '/dashboard/profilo', icon: 'bi-person', label: 'Profilo' },
      {
        path: '/dashboard/notifiche',
        icon: 'bi-bell',
        label: 'Notifiche',
        badgeCount: unreadCount,
      },
    ],
    [unreadCount]
  );

  return (
    <DashboardLayout
      navItems={navItems}
      areaLabel="Dashboard"
      notifPath="/dashboard/notifiche"
      unreadCount={unreadCount}
    />
  );
};

export default UserLayout;
